import { isWechatMiniProgram } from './env';
import { json2query } from './url';

type ValueOf<T> = T[keyof T];

export const JumpMethod = {
  navigateTo: 'navigateTo' as const,
  redirectTo: 'redirectTo' as const,
};

type JumpMethodType = ValueOf<typeof JumpMethod>;

// 页面路径schema
export const pageSchema = {
  // 原生小程序tab页
  miniappTab: 'miniapp_tab://',
  // 原生小程序非tab页
  miniappNative: 'miniapp_native://',
  // 退出当前原生页面，往回退一层
  back: 'back://',
};

interface OpenH5Args {
  url: string;
  jumpMethod: JumpMethodType;
}

/**
 * 在新的webview容器打开H5
 * @param args
 * @param {string} args.url
 * @param {'navigateTo' | 'redirectTo'} args.jumpMethod
 */
export function openH5InNewWebview(args: OpenH5Args) {
  const {
    url,
    jumpMethod = 'navigateTo',
  } = args;
  const location = window.location;
  let finalUrl = url;
  if (!/^https?\:\/\//.test(finalUrl)) {
    finalUrl = `${location.protocol}//${location.host}${url}`;
  }
  if (isWechatMiniProgram()) {
    window.wx.miniProgram[jumpMethod]({
      url: `/pages/h5/h5?url=${encodeURIComponent(finalUrl)}`,
    });
  } else {
    window.open(url);
  }
}

interface MiniProgramPayArgs {
  serviceType: string;
  months: number;
  // 支付成功后，跳转的目标页面
  targetUrl: string;
  jumpMethod: JumpMethodType;
}
/**
 * 打开小程序支付中间页
 * @param args
 */
export function openMiniProgramPayLanding(args: MiniProgramPayArgs) {
  const {
    jumpMethod = JumpMethod.navigateTo,
    ...payArgs
  } = args;
  window.wx.miniProgram[jumpMethod]({
    url: `/pages/pay/pay?${json2query(payArgs as unknown as Record<string, string>)}`,
  });
}

interface OpenPageArgs {
  url: string;
  jumpMethod?: JumpMethodType;
}

/**
 * 跳转到某个页面，可能是小程序tab、小程序原生页面以及H5页面
 * @param args {object} 跳转参数
 * @param args.url {string} 页面链接
 * @param args.jumpMethod {boolean} 是否替换当前页面
 */
export function openPage(args: OpenPageArgs) {
  const url = args.url;
  const jumpMethod = args.jumpMethod || 'navigateTo';
  if (url.indexOf(pageSchema.miniappTab) >= 0) {
    // 跳转到小程序的某个tab页
    window.wx.miniProgram.switchTab({
      url: url.replace(pageSchema.miniappTab, ''),
    });
  } else if (url.indexOf(pageSchema.miniappNative) >= 0 || url.indexOf('/') === 0) {
    // 跳转到某个小程序原生页面
    const finalUrl = url.replace(pageSchema.miniappNative, '');
    const jumpArgs = {
      url: finalUrl,
    };
    window.wx.miniProgram[jumpMethod](jumpArgs);
  } else if (url === pageSchema.back) {
    // 回退一层页面
    window.wx.miniProgram.navigateBack();
  } else {
    if (/^https?:\/\//.test(args.url)) {
      // 完整的URL，直接走浏览器跳转
      // 普通H5跳转，在当前webview内跳
      openH5InNewWebview({
        url: args.url,
        jumpMethod,
      });
    } else {
      // 走页面内跳转
      alert('不支持的跳转路径');
    }
  }
}
